import React from 'react';
import { APP } from '../../../../config';

/**
 * Renders several static `<script>` tags used for SEO purposes.
 */
const SEOTags = () => {
  if (APP) {
    return null;
  }

  return (
    <React.Fragment>
      <script type="application/ld+json">
        {`
        {
          "@context":"https://schema.org",
          "@id":"#WebSite",
          "@type":"WebSite",
          "url":"https://www.styleseat.com",
          "name":"StyleSeat",
          "publisher":
          {
            "@id":"#Organization"
          },
          "copyrightHolder":
          {
            "@id":"#Organization"
          },
          "copyrightYear":"${new Date().getFullYear()}",
          "inLanguage":"en-US",
          "potentialAction":
          {
            "@type":"SearchAction",
            "target":"https://www.styleseat.com/m/search/list?q={search_term_string}&loc=Current%20Location",
            "query-input":"required name=search_term_string"
          }
        }
        `}
      </script>
      <script type="application/ld+json">
        {`
        {
          "@context":"https://schema.org",
          "@id":"https://www.styleseat.com",
          "@type":"WebPage",
          "name":"StyleSeat - Online Booking for Hair Stylists & Beauty Professionals",
          "description":"StyleSeat is the online destination for beauty & wellness professionals and clients. Professionals can showcase their work, connect with new and existing clients, and build their business. Clients can discover new services and providers, book appointments online, and get inspired",
          "datePublished": "${new Date().toISOString()}",
          "dateModified":"${new Date().toISOString()}",
          "isPartOf":
          {
            "@id":"https://www.styleseat.com#WebSite"
          }
        }
        `}
      </script>
      <script type="application/ld+json">
        {`
        {
          "@context":"https://schema.org",
          "@id":"#BreadcrumbList",
          "@type":"BreadcrumbList",
          "@reverse":
          {
            "breadcrumb":
            {
              "@id":"https://www.styleseat.com"
            }
          },
          "itemListElement":
          [
            {
              "@type":"ListItem",
              "position":1,
              "item":
              {
                "@id":"https://www.styleseat.com",
                "name":"Home"
              }
            }
          ]
        }
        `}
      </script>
      <script type="application/ld+json">
        {`
        {
          "@context":"https://schema.org",
          "@id":"#Organization",
          "@type":"Organization",
          "name":"StyleSeat",
          "url":"https://www.styleseat.com",
          "logo":
          {
            "@type":"ImageObject",
            "url":"https://d4u5qzkfpc9yt.cloudfront.net/ss_logo_01.png",
            "width":"818",
            "height":"818"
          },
          "sameas":
          [
            "https://www.facebook.com/styleseat",
            "https://twitter.com/styleseat",
            "https://www.snapchat.com/add/styleseat",
            "https://www.instagram.com/styleseat/"
          ]
        }
        `}
      </script>
    </React.Fragment>
  );
};

export default SEOTags;
